const toMb = (v) => v / 1e6;
export default toMb;
